module.exports = __webpack_public_path__ + "media/images/conlance_logo-aeda911037852bf2775928342398700b.png";